/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * Standard error response object
 */
export type PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponseData = {
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;
};

/**
 * Standard error response object
 */
export class PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse
  extends Error
{
  error: string;
  code?: string | undefined;
  details?: any | null | undefined;

  /** The original data that was passed to this error instance. */
  data$: PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponseData;

  constructor(
    err: PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponseData,
  ) {
    const message = "message" in err && typeof err.message === "string"
      ? err.message
      : `API error occurred: ${JSON.stringify(err)}`;
    super(message);
    this.data$ = err;

    this.error = err.error;
    if (err.code != null) this.code = err.code;
    if (err.details != null) this.details = err.details;

    this.name = "PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse";
  }
}

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$inboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse,
    z.ZodTypeDef,
    unknown
  > = z.object({
    error: z.string(),
    code: z.string().optional(),
    details: z.nullable(z.any()).optional(),
  })
    .transform((v) => {
      return new PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse(v);
    });

/** @internal */
export type PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound =
  {
    error: string;
    code?: string | undefined;
    details?: any | null | undefined;
  };

/** @internal */
export const PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$outboundSchema:
  z.ZodType<
    PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound,
    z.ZodTypeDef,
    PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse
  > = z.instanceof(PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse)
    .transform(v => v.data$)
    .pipe(z.object({
      error: z.string(),
      code: z.string().optional(),
      details: z.nullable(z.any()).optional(),
    }));

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$ {
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$inboundSchema` instead. */
  export const inboundSchema =
    PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$inboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$outboundSchema` instead. */
  export const outboundSchema =
    PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$outboundSchema;
  /** @deprecated use `PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound` instead. */
  export type Outbound =
    PutApiLeadScraperMicroserviceApiV1OrganizationErrorResponse$Outbound;
}
